<template>
  <BaseBulkSendFeatureUnavailableEmptyState>
    <p>{{ $t('ui.bulkSend.emptyState.featureUnavailable.infoNonSuperAdmin') }}</p>
  </BaseBulkSendFeatureUnavailableEmptyState>
</template>

<script>
import BaseBulkSendFeatureUnavailableEmptyState
  from '@/components/ui/bulkSend/BaseBulkSendFeatureUnavailableEmptyState.vue';

export default {
  name: 'BulkSendFeatureUnavailableEmptyStateNonSuperAdmin',
  components: {
    BaseBulkSendFeatureUnavailableEmptyState,
  },
};
</script>
